import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './components/App'
import router from './router'
import store from './store'
import 'filters'
// import VeeValidate, {Validator} from 'vee-validate'
// import zh from 'vee-validate/dist/locale/zh_CN'
import myValid from 'components/validate/myValidate'

Vue.use(myValid)

/*
Validator.addLocale(zh);
const config = {
    locale: 'zh_CN'
};
Vue.use(VeeValidate, config)
*/

sync(store, router)

const app = new Vue({
    router,
    store,
    ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./src/app.js